/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `female` - female * `male` - male
 */
export type Gender7aaEnum = 'female' | 'male';

export const Gender7aaEnum = {
    Female: 'female' as Gender7aaEnum,
    Male: 'male' as Gender7aaEnum
};